import { Typography } from '@mui/material'
import { FC } from 'react'
import { LicenseStateProps, LicenseStates } from './types'
import { useStore } from 'effector-react'
import { $license } from '../../store/getLicense'
import { isNull } from 'lodash'
import moment from 'moment'

export const LicenseState: FC<LicenseStateProps> = ({ state }) => {
  const license = useStore($license)
  const color = state === LicenseStates.ACTIVE ? 'green' : 'red'

  if (state === LicenseStates.INVALID) {
    return (
      <Typography sx={{ color }}>
        Лицензионный ключ не действительный
      </Typography>
    )
  }

  if (isNull(license.key.validUntil)) {
    return (
      <Typography sx={{ color }}>
        Лицензионный ключ активен на бессрочный период
      </Typography>
    )
  }
  return (
    <Typography sx={{ color }}>
      Лицензионный ключ активен до:{' '}
      {moment(license.key.validUntil).format('DD-MM-YYYY')}
    </Typography>
  )
}
